// extracted by mini-css-extract-plugin
module.exports = {"carouselsBlock":"styles_carouselsBlock__zI_34","carouselRow":"styles_carouselRow__msLAP","list":"styles_list__O6O82","item":"styles_item__4f_0t"};